<template>
    <div class="component-container">
        <div class="component-title">
            <span>模拟资金账户申请</span>
        </div>
        <div class="component-wrapper">
            <div class="operate-zone">
                <!-- <vue-button @click="addAccount">添加账户</vue-button> -->
                <button @click="addAccount">
                    <img src="~@/assets/img/button_primary_icon.png" alt="">
                    <span v-stat="$stats.personalCenter.addAccount">添加账户</span>
                </button>
            </div>
            <account-list :account-list="list" class="content-zone"></account-list>
            <div class="empty" v-if="list.length === 0">
                <img src="~@/assets/img/empty.png" alt="">
                <p>点击添加账户按钮添加账户</p>
                <button @click="addAccount">
                    <img src="" alt="">
                    <span v-stat="$stats.personalCenter.addAccount">添加账户</span>
                </button>
            </div>
            <vue-pagination
                class="strategy-page"
                :page-size="pageNum"
                :total="total"
                @current-change="goPage">
            </vue-pagination>
        </div>
        <add-dialog :visible.sync="dVisi" @update-list="updateList"></add-dialog>
    </div>
</template>

<script>
import cookieApi from '@/lib/cookieApi'
import axios from 'axios'
import accountList from './list'
import dialog from './add'
import { mapState } from 'vuex'
export default {
    components: {
        'account-list': accountList,
        'add-dialog': dialog
    },
    data () {
        return {
            dVisi: false,
            list: [
                // {
                //     account_id: 56348539,
                //     asset: 500,
                //     pwd: 'sdfagfdgahgagh',
                //     token: 'sdfgsdfhadfghajgajkdsgjlkagdhakldgfajkldghakjFSDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD',
                //     remark: '这是一段描述大纲的第三方',
                //     created_at: '2019-06-20 10:29:53'
                // },
                // {
                //     account_id: 56348539,
                //     asset: 500,
                //     pwd: 'sdfagfdgahgagh',
                //     token: 'sdfgsdfhadfghajgajkdsgjlkagdhakldgfajkldghakj',
                //     remark: '这是一段描述大纲的第三方',
                //     created_at: '2019-06-20 10:29:53'
                // },
                // {
                //     account_id: 56348539,
                //     asset: 500,
                //     pwd: 'sdfagfdgahgagh',
                //     token: 'sdfgsdfhadfghajgajkdsgjlkagdhakldgfajkldghakj',
                //     remark: '这是一段描述大纲的第三方',
                //     created_at: '2019-06-20 10:29:53'
                // },
                // {
                //     account_id: 56348539,
                //     asset: 500,
                //     pwd: 'sdfagfdgahgagh',
                //     token: 'sdfgsdfhadfghajgajkdsgjlkagdhakldgfajkldghakj',
                //     remark: '这是一段描述大纲的第三方',
                //     created_at: '2019-06-20 10:29:53'
                // },
                // {
                //     account_id: 56348539,
                //     asset: 500,
                //     pwd: 'sdfagfdgahgagh',
                //     token: 'sdfgsdfhadfghajgajkdsgjlkagdhakldgfajkldghakjaaaaaaa',
                //     remark: '这是一段描述大纲的第三方',
                //     created_at: '2019-06-20 10:29:53'
                // }
            ],
            page: 1,
            pageNum: 5,
            total: 0
        }
    },
    computed: {
        ...mapState(['isFirst'])
    },
    methods: {
        goPage (page) {
            this.page = page
            // updateList()
        },
        updateList () {
            var self = this
            return axios.get('/simu_account/query', {
                params: {
                    page: self.page,
                    page_num: self.pageNum
                }
            })
                .then(response => {
                    let body = response.data
                    if (body.status_code === 0) {
                        self.list = body.result.list
                        self.total = body.result.total
                    } else if (body.status_code === -401) {
                    } else {
                        // self.$tip({
                        //     message: body.status_msg,
                        //     duration: 2000,
                        //     type: 'warning'
                        // })
                        self.$message({
                            message: body.status_msg,
                            duration: 2000,
                            type: 'warning'
                        })
                    }
                })
                .catch(error => {
                    // self.$tip({
                    //     message: error ? error.message : '网络异常',
                    //     duration: 2000,
                    //     type: 'error'
                    // })
                    self.$message({
                        message: error ? error.message : '网络异常',
                        duration: 0,
                        type: 'error',
                        showClose: true
                    })
                })
        },
        addAccount () {
            if (cookieApi.get('user')) this.dVisi = true
            // else window.ThsLogin.showLoginBox('//' + document.domain + '/developer/pop-login.html')
            else window.LoginInstance.show()
        },
        loginAccount (accountlist) {
            if (accountlist.length === 0) return
            return this.$api.account.addAccount({
                accountlist: accountlist.map(account => ({
                    accountid: account.account_id,
                    password: account.pwd,
                    IsAutoTransIP: false,
                    SiteIP: 'trade.10jqka.com.cn',
                    accountkey: `${account.account_id}|0|0`,
                    accountmark: '--',
                    bindstatus: 0,
                    dynamicpassword: '',
                    issimulate: 1,
                    qsid: '56',
                    broker_id: '56',
                    counter_id: null,
                    qsname: '模拟炒股',
                    tradetype: 0,
                    txpassword: '',
                    userkey: '',
                    yybid: '0',
                    yybname: '同花顺模拟炒股'
                }))
            })
        },
        setConfig () {
            return new Promise((resolve, reject) => {
                window.cef.setConfig({
                    filename: `forfunds-developer-${cookieApi.get('userid')}.cfg`,
                    isFirst: 'false'
                }, res => {
                    res = res && JSON.parse(res)
                    if (res.retcode === 0) {
                        resolve()
                    } else {
                        reject(res.message)
                    }
                }, error => {
                    reject(error)
                })
            })
        },
        getConfig () {
            return new Promise((resolve, reject) => {
                window.cef.getConfig({
                    filename: `forfunds-developer-${cookieApi.get('userid')}.cfg`,
                    isFirst: ''
                }, res => {
                    res = res && JSON.parse(res)
                    if (+res.retcode === 0) {
                        resolve(res.isFirst !== 'false')
                    } else {
                        resolve(true)
                    }
                }, error => {
                    reject(error)
                })
            })
        },
        loadCefEnd () {
            return new Promise(resolve => {
                if (window.cef) {
                    resolve()
                } else {
                    setTimeout(async () => {
                        await this.loadCefEnd()
                        resolve()
                    }, 500)
                }
            })
        }
    },
    async created () {
        if (cookieApi.get('user')) {
            try {
                await this.updateList()
                if (window.cefQuery) {
                    await this.loadCefEnd()
                    await this.$store.dispatch('getLoginInfo')
                    const isWebFirst = await this.getConfig()
                    await this.setConfig()
                    if (!this.isFirst || !isWebFirst) return
                    let applyList = []
                    for (let i = 0; i < 3 - this.list.length; i++) {
                        applyList.push(axios.post('/simu_account/apply', {
                            asset: 10000000,
                            remark: ''
                        }))
                    }
                    await Promise.all(applyList)
                    await this.updateList()
                    this.loginAccount(this.list.slice(0, 3))
                }
            } catch (error) {
                console.log(error)
            }
        }
    },
    watch: {
        page () {
            this.updateList()
        }
    }
}
</script>

<style lang="scss" scoped>
.component-container {
    height: 100%;
    background: #f3f3f3;
    .component-title {
        height: 60px;
        line-height: 60px;
        padding-left: 30px;
        background: white;
        span {
            color: black;
            font-weight: bold;
        }
    }
    .component-wrapper {
        margin: 25px 25px 0 25px;
        padding: 30px 30px 70px 30px;
        background: white;
        // height: calc(100% - 85px);
        box-sizing: border-box;
        min-height: calc(100vh - 254px);
        position: relative;
        .strategy-page {
            text-align: right;
            padding: 20px 0;
            position: absolute;
            right: 30px;
            bottom: 0;
        }
        .empty {
            text-align: center;
            margin-top: 100px;
            > p {
                font-size: 16px;
                color: #666666;
            }
            button {
                width: 190px;
                height: 40px;
                border-radius: 4px;
                border: 1px solid #108ee9;
                font-size: 14px;
                color: #108ee9;
                background: transparent;
                cursor: pointer;
            }
        }
    }
    .operate-zone {
        height: 32px;
        button {
            float: left;
            width: 105px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: #1890ff;
            color: white;
            border: none;
            border-radius: 4px;
            cursor: pointer;
            vertical-align: middle;
            img {
                display: inline-block;
                vertical-align: middle;
                margin-right: 5px;
            }
            span {
                display: inline-block;
                vertical-align: middle;
            }
        }
        .tip {
            float: left;
            height: 30px;
            line-height: 30px;
            margin-left: 24px;
            padding: 0 15px;
            background: #f7f6f6;
            border-radius: 4px;
            border: 1px solid #ededed;
            img {
                width: 14px;
                height: 14px;
                vertical-align: middle;
                margin-right: 5px;
            }
            span {
                font-size: 14px;
                color: #666666;
            }
        }
    }
    // .pagination {
    //     height: 70px;
    //     display: flex;
    //     justify-content: flex-end;
    //     align-items: center;
    //     div {
    //         width: 30px;
    //         height: 30px;
    //         line-height: 30px;
    //         text-align: center;
    //         margin-left: 8px;
    //         border: 1px solid #d9d9d9;
    //         border-radius: 6px;
    //         font-size: 14px;
    //         color: rgba(0, 0, 0, 0.65);
    //         cursor: pointer;
    //         &.active {
    //             border-color: #1890ff;
    //             background: #1890ff;
    //             color: white;
    //         }
    //     }
    // }
}
</style>



// WEBPACK FOOTER //
// src/components/simuAccountApplication/index.vue